export const initialState = {
    data: {
        eficiencia_geral: null,
        trama_cmpx: null,
        urdume_cmpx: null,
        eficiencia_baixa: null,
        eficiencia_minima: null,
        grupos: [],
        producao: {
            turma: null,
            meta_producao_diaria: null,
            producao_atual: 0,
            percentual: null
        },
        updated_at: null
    },
    previousData: null,
    hasFetched: false,
    isLoading: true,
    error: "",
    pollingMinutes: 5
};

export function eficienciaTelevisaoReducer(state, action) {
    switch (action.type) {
        case "FETCH_SUCCESS":
            return {
                ...state,
                previousData: state.hasFetched ? state.data : null,
                data: action.payload,
                hasFetched: true,
                isLoading: false,
                error: ""
            };
        case "FETCH_ERROR":
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        case "SET_POLLING_MINUTES":
            return {
                ...state,
                pollingMinutes: action.payload
            };
        default:
            return state;
    }
}
